import React from 'react';
import '../StyleComponent/ICICIBankThankYou.css';
import { useNavigate,Link } from 'react-router-dom'; // Import the useNavigate hook
import { GiCheckMark } from "react-icons/gi";



const ICICIBankThankYou = () => {
  const navigate = useNavigate(); // Initialize the navigate function

  const onClose = () => {
    // Perform some action, like navigating away or hiding the component
    console.log("Close button clicked");
    navigate('/');

  };
  return (
    <div className="icici-thank-you-container">
      <header className="icici-header1">
        {/* <img src={require("../Assets/logo.png")} alt="ICICI Bank" className="icici-logo" /> */}
      </header>
      <button className="close-btn" onClick={onClose}>
          ×
        </button>
      <main className="icici-main">
        <div className="thank-you-message">
          <div className="check-icon"><GiCheckMark /></div>
          <h1>Thank You for showing your interest in ICICI Bank Payment collection solutions.</h1>
          <p>Our representative will reach out to you in a while.</p>
        </div>
      </main>
      <footer className="icici-footer1">
      <p>
                *Terms and Conditions of ICICI Bank apply. For details{" "}
                <Link to="/ClickHere">Click Here.</Link>
              </p>
              <p>
                Corporate Office Address: ICICI Bank Towers, Bandra-Kurla
                Complex, Mumbai 400 051
              </p>
                </footer>
    </div>
  );
};

export default ICICIBankThankYou;